import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardDossierStatesDefinition } from '../create-dossier-states-definition';
import { DossierShell } from '../dossier-shell.profile';
import {
  DossierInfoMetricProfile,
  dossierInfoEconomicParticipantProfile,
  dossierInfoEmployedProfile,
  dossierInfoGvaProfile,
  dossierInfoRevenueProfile,
  dossierInfoTaxedProfile,
} from './dashboard-dossier-states-info-metric.profile';
import { DashboardDossierStatesInfoDefinition } from './dashboard-dossier-states-info.definition';

/**
 * Product catalog for dossier states info (übersicht).
 * Identity is derived in {@link createDashboardDossierStatesDefinition}.
 */

// Pending datasets: Tourism and SelfEmployed dossiers.
type DossierInfoMetric = Exclude<Metric, Metric.Tourism | Metric.SelfEmployed>;

export const DOSSIER_STATES_INFO_PRODUCT_CATALOG: Record<
  DossierInfoMetric,
  ProductCatalogEntry<DossierInfoMetricProfile, DossierShell>
> = {
  [Metric.CompaniesCount]: {
    metric: dossierInfoTaxedProfile,
    shells: ['info'],
  },
  [Metric.CompaniesRevenue]: {
    metric: dossierInfoRevenueProfile,
    shells: ['info'],
  },
  [Metric.GrossValueAdded]: {
    metric: dossierInfoGvaProfile,
    shells: ['info'],
  },
  [Metric.EconomicParticipant]: {
    metric: dossierInfoEconomicParticipantProfile,
    shells: ['info'],
  },
  [Metric.Employed]: {
    metric: dossierInfoEmployedProfile,
    shells: ['info'],
  },
};

/** All dossier states info (übersicht) product definitions. */
export const DOSSIER_STATES_INFO_DEFINITIONS: DashboardDossierStatesInfoDefinition[] =
  expandProductCatalog(
    Object.values(DOSSIER_STATES_INFO_PRODUCT_CATALOG),
    createDashboardDossierStatesDefinition,
  );
